import { render, staticRenderFns } from "./PatientDetailImageDescriptionByMonth.vue?vue&type=template&id=11db9980&scoped=true&"
import script from "./PatientDetailImageDescriptionByMonth.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailImageDescriptionByMonth.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailImageDescriptionByMonth.vue?vue&type=style&index=0&id=11db9980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11db9980",
  null
  
)

export default component.exports